import { all, takeEvery } from 'redux-saga/effects'
import { getTemplateSaga } from 'store/template/sagas/get-template.saga'
import * as actions from 'store/template/template.actions'

export default function* templateSaga() {
  yield all([takeEvery(actions.GET_TEMPLATE_REQUEST, getTemplateSaga)])
}
